import React from "react";

const MCQQuestion = ({ question, options, onOptionSelect, selectedOption, submitted }) => {
  const handleOptionChange = (event) => {
    onOptionSelect(event.target.value);
  };

  return (
    <div className="max-w-full rounded overflow-hidden shadow-lg mt-4 mx-4 bg-white p-4">
      <p className="font-bold text-lg mb-2">{question}</p>
      <div>
        {Array.isArray(options) ? (
          options.map((option, index) => (
            <div
              key={index}
              className={`flex items-center mb-2 ${
                submitted
                  ? selectedOption === option.options
                    ? option.correct === 1
                      ? "text-green-600"
                      : "text-red-600"
                    : ""
                  : ""
              }`}
            >
              <input
                type="radio"
                id={`option${index}`}
                name="mcqOption"
                value={option.options}
                checked={selectedOption === option.options}
                onChange={handleOptionChange}
                className="mr-2"
                disabled={submitted}
              />
              <label htmlFor={`option${index}`}>{option.options}</label>
            </div>
          ))
        ) : (
          <p>No options available</p>
        )}
      </div>
    </div>
  );
};

export default MCQQuestion;
